import { Mesh, Vector3, Color4, Vector2, Scene, ArcRotateCamera, Matrix, AbstractMesh, Quaternion } from '@babylonjs/core';
import { Vector } from '../../utils/Vector';
import { Ellipse, AdvancedDynamicTexture, Control, Rectangle, Image, TextBlock, StackPanel } from '@babylonjs/gui';
import { Player } from '../player/Player';
import { GlobalObject } from '../../utils/GlobalObject';
import { CrossEvent } from './../../event/CrossEvent';
import { Boardcaster } from '../../event/Boadcaster';

export class FacilityInfo {
    private static _instance: FacilityInfo;
    private gui: AdvancedDynamicTexture;
    private mc?: Rectangle;
    private closeBtn?: Image;
    private enterBtn?: Image;
    private source?: any;
    private txt_1?: TextBlock;
    private txt_2?: TextBlock;
    private txt_3?: TextBlock;
    private txt_4?: TextBlock;
    private txt_5?: TextBlock;
    private txt_6?: TextBlock;
    private isShow = true;
    private equipmentData?: any;

    constructor() {
        let gui = GlobalObject.getInstance().main.gui;
        if (gui) {
            this.gui = gui;
        } else {
            this.gui = AdvancedDynamicTexture.CreateFullscreenUI("UI");
            this.gui.idealWidth = 1000;
        }
        this.source = GlobalObject.getInstance().main.source.common;
        this.initUI();
    }
    public static getInstance() {
        if (!this._instance) this._instance = new FacilityInfo();
        return this._instance;
    }
    private initUI() {
        this.mc = new Rectangle();
        // 左下角
        this.mc.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.mc.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this.mc.width = "160px";
        this.mc.height = "195px";
        this.mc.top = "10px";
        this.mc.left = "200px";
        this.mc.color = "#ffcc0000";
        this.gui.addControl(this.mc);
        this.mc.isPointerBlocker = true;  // 允许鼠标交互

        let image = new Image("bg2", this.source.facilityInfoBg);
        image.width = "160px";
        image.height = "195px";
        image.top = 0;
        image.left = 0;
        this.mc.addControl(image);


        this.txt_1 = this.createText();
        this.txt_1.top = -52;
        this.txt_2 = this.createText();
        this.txt_2.top = -33;
        this.txt_3 = this.createText();
        this.txt_3.top = -14;
        this.txt_4 = this.createText();
        this.txt_4.top = 5;
        this.txt_5 = this.createText();
        this.txt_5.top = 24;
        this.txt_6 = this.createText();
        this.txt_6.top = 44;


        this.closeBtn = new Image("close_btn", this.source.facilityInfoBCloseBtn);
        this.closeBtn.width = "12px";
        this.closeBtn.height = "12px";
        this.mc.addControl(this.closeBtn);
        this.closeBtn.top = -75;
        this.closeBtn.left = 65;


        this.enterBtn = new Image("enter_btn", this.source.facilityInfoBtn);
        this.enterBtn.width = "64px";
        this.enterBtn.height = "22.5px";
        this.mc.addControl(this.enterBtn);
        this.enterBtn.top = 76;
        this.enterBtn.left = 0;

        this.hide();

        //this.loadImg();
        (this.enterBtn as Image).onPointerUpObservable.add(() => {
            this.openEquipment();
            this.hide();
        });
        this.enterBtn.onPointerEnterObservable.add(() => {
            document.body.style.cursor='pointer'; // 光标改成手型
        });
        this.enterBtn.onPointerOutObservable.add(() => {
            document.body.style.cursor=''; // 光标改成默认箭头
        });
        (this.closeBtn as Image).onPointerUpObservable.add(() => {
            this.hide();
        });
        this.closeBtn.onPointerEnterObservable.add(() => {
            document.body.style.cursor='pointer'; // 光标改成手型
        });
        this.closeBtn.onPointerOutObservable.add(() => {
            document.body.style.cursor=''; // 光标改成默认箭头
        });
    }
    public addToMesh(mesh: Mesh, data: any) {
        this.show();
        this.equipmentData = data;
        if (this.mc) {
            this.mc.linkWithMesh(mesh);
            // 右边
            this.mc.linkOffsetX = 120;
            this.mc.linkOffsetY = 100;
        }
        let id = data.id;
        let msg = { type: "getFacilityById", data: { name: id, macno: id } }
        Boardcaster.getInstance().send(msg);
    }
    private openEquipment() {
        const emitter = CrossEvent.getInstance().getEmitter();
        emitter.emit(CrossEvent.getInstance().OPEN_EQUIPMENT, {
            data: this.equipmentData || {},
            descript: "点击了热区模型，查看对应设备详情",
            from: this.equipmentData.from || '',
            eventType: "CrossEvent",
        });
    }
    public setText(data: any = {}) {
        (this.txt_1 as TextBlock).text = data['设备编号'] || '';
        (this.txt_2 as TextBlock).text = data['设备名称'] || '';
        (this.txt_3 as TextBlock).text = data['物号'] || '';
        (this.txt_4 as TextBlock).text = data['加工物料名称'] || '';
        (this.txt_5 as TextBlock).text = data['工序名称'] || '';
        (this.txt_6 as TextBlock).text = data['姓名'] || '';
        
    }
    private createText(str: string = "045-073"): TextBlock {
        const txt = new TextBlock();
        txt.textHorizontalAlignment = TextBlock.HORIZONTAL_ALIGNMENT_LEFT;
        txt.text = str;
        txt.color = "#0affff";
        txt.fontSize = 8;
        txt.left = 55;
        (this.mc as Rectangle).addControl(txt);
        return txt;
    }
    public getVisible() {
        return this.isShow;
    }
    public hide() {
        this.isShow = false;
        (this.mc as Rectangle).isVisible = false;
    }
    public show() {
        this.isShow = true;
        (this.mc as Rectangle).isVisible = true;
    }
}